/* eslint-disable @typescript-eslint/no-var-requires */
const ICO_BCMC = require("./images/ico_bcmc.png");
const ICO_CIRCLE = require("./images/ico_circle.svg");
const ICO_CLOSE = require("./images/ico_close.svg");
const ICO_CLOSE_ERROR = require("./images/ico_close_error.svg");
const ICO_CLOSE_INFO = require("./images/ico_close_info.svg");
const ICO_CLOSE_ROUND = require("./images/ico_close_round.svg");
const ICO_CLOSE_SUCCESS = require("./images/ico_close_success.svg");
const ICO_CURRENCY_TAG = require("./images/ico_currency_tag.svg");
const ICO_IBANISATION = require("./images/ico_ibanisation.png");
const ICO_IDEAL_WERO = require("./images/ico_ideal_wero.png");
const ICO_PAYCONIQ = require("./images/ico_payconiq.png");
const ICO_PHONE = require("./images/ico_phone.svg");
const ICO_PROFILE_ROUND = require("./images/ico_profile_round.svg");
const ICO_QR_PROVIDERS = require("./images/ico_qr_providers@3x.png");
const ICO_SEPA = require("./images/ico_sepa.svg");
const IMG_BACKGROUND_LEFT_1 = require("./images/img_background_left_1.jpg");
const IMG_BACKGROUND_LEFT_2 = require("./images/img_background_left_2.jpg");
const IMG_BACKGROUND_LEFT_3 = require("./images/img_background_left_3.jpg");
const IMG_BACKGROUND_LEFT_4 = require("./images/img_background_left_4.jpg");
const IMG_BACKGROUND_LEFT_5 = require("./images/img_background_left_5.jpg");
const IMG_BACKGROUND_RIGHT_1 = require("./images/img_background_right_1.jpg");
const IMG_BACKGROUND_RIGHT_2 = require("./images/img_background_right_2.jpg");
const IMG_BACKGROUND_RIGHT_3 = require("./images/img_background_right_3.jpg");
const IMG_BACKGROUND_RIGHT_4 = require("./images/img_background_right_4.jpg");
const IMG_BACKGROUND_RIGHT_5 = require("./images/img_background_right_5.jpg");
const IMG_RENTIO_LOGO = require("./images/img_rentio_logo.png");
const IMG_RENTIO_LOGO_COPYRIGHT = require("./images/img_rentio_logo_copyright.png");

// eslint-disable-next-line import/no-default-export
export default {
  ICO_BCMC,
  ICO_CIRCLE,
  ICO_CLOSE_ERROR,
  ICO_CLOSE_INFO,
  ICO_CLOSE_ROUND,
  ICO_CLOSE_SUCCESS,
  ICO_CLOSE,
  ICO_CURRENCY_TAG,
  ICO_IBANISATION,
  ICO_IDEAL_WERO,
  ICO_PAYCONIQ,
  ICO_PHONE,
  ICO_PROFILE_ROUND,
  ICO_QR_PROVIDERS,
  ICO_SEPA,
  IMG_BACKGROUND_LEFT_1,
  IMG_BACKGROUND_LEFT_2,
  IMG_BACKGROUND_LEFT_3,
  IMG_BACKGROUND_LEFT_4,
  IMG_BACKGROUND_LEFT_5,
  IMG_BACKGROUND_RIGHT_1,
  IMG_BACKGROUND_RIGHT_2,
  IMG_BACKGROUND_RIGHT_3,
  IMG_BACKGROUND_RIGHT_4,
  IMG_BACKGROUND_RIGHT_5,
  IMG_RENTIO_LOGO_COPYRIGHT,
  IMG_RENTIO_LOGO,
};
